import React, { useState, useEffect, useCallback } from 'react';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useAccessToken, callMsGraph } from '../../hooks/useAuth';
import styles from './auth.module.css';

const UserProfile = () => {
    const isAuthenticated = useIsAuthenticated();
    const { accounts } = useMsal();
    const { getAccessToken } = useAccessToken();
    const [graphData, setGraphData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [hasAttemptedFetch, setHasAttemptedFetch] = useState(false);

    const fetchUserData = useCallback(async () => {
        if (!isAuthenticated || accounts.length === 0 || hasAttemptedFetch) {
            return;
        }

        setLoading(true);
        setHasAttemptedFetch(true);
        
        try {
            const accessToken = await getAccessToken();
            const userData = await callMsGraph(accessToken);
            setGraphData(userData);
        } catch (error) {
            console.error("Failed to fetch user data:", error);
            // Reset the attempt flag on error so user can retry
            setHasAttemptedFetch(false);
        } finally {
            setLoading(false);
        }
    }, [isAuthenticated, accounts, getAccessToken, hasAttemptedFetch]);

    useEffect(() => {
        fetchUserData();
    }, [fetchUserData]);

    // Reset state when user logs out
    useEffect(() => {
        if (!isAuthenticated) {
            setGraphData(null);
            setLoading(false);
            setHasAttemptedFetch(false);
        }
    }, [isAuthenticated]);

    if (!isAuthenticated) {
        return null;
    }

    const account = accounts[0];

    return (
        <div className={styles['user-profile']}>
            <div className={styles['user-info']}>
                <div className={styles['user-name']}>
                    {loading && !graphData ? (
                        account?.name || 'Loading...'
                    ) : (
                        graphData?.displayName || account?.name || 'User'
                    )}
                </div>
                <div className={styles['user-email']}>
                    {loading && !graphData ? (
                        account?.username || ''
                    ) : (
                        graphData?.mail || account?.username || ''
                    )}
                </div>
                
            </div>
        </div>
    );
};

export default UserProfile;
